import requester from '@/utils/request'
export const walletService: any = {
  clickShareLink: (data: any) => requester.post('/actor/v1/report/login-event', data),
  tgLogin: (data: any) => requester.post('/dfans/telegram/mini-app/login', data),
  login: (data: any, config: any) => requester.post('/dfans/v1/global/login', data, config),
  // 邮箱密码登录
  emailPasswordLogin: (data: any, config: any) =>
    requester.post('/dfans/v1/login/password', data, config),
  // 邮箱密码注册
  emailPasswordRegister: (data: any) => requester.post('/dfans/v1/register/password', data),
  // 发送邮箱验证码
  sendEmailCode: (data: any) => requester.post('/dfans/v1/mail/verification-code', data),
  // 钱包余额获取 及汇率
  balanceQuery: (data: any) => requester.post('/wallet/v1/balance/query', data),
  // 获取 汇率
  queryExchangeRate: (data: any) =>
    requester.post(`/charge/common/query-exchange-rate?targetCurrency=${data.targetCurrency}`, {}),
  // 法币购买数字货币
  buyLegalCurrency: (data: any) =>
    requester.post('/wallet/cryptocurrency/purchase/by/legal-currency', data),
  // 用户查看自己的分红历史记录
  queryRevenueHistory: (data: any) => requester.post('/wallet/v1/queryRevenueHistory', data),
  // 获取用户投资的创作者信息（包括投资的金额）
  queryInvestCreator: (data: any) => requester.post('/invest/v1/queryInvestCreator', data),
  // 获取用户投资的创作者-投资金额-分红金额-可提现金额
  queryInvestSummary: (data: any) => requester.post('/invest/v1/queryInvestSummary', data),
  // 查询充值状态
  depositStatus: (data: any) => requester.post('/wallet/transaction/v1/deposit-status', data),
  // 提现到个人钱包
  withdraw: (data: any) => requester.post('/wallet/v1/withdraw', data),
  // 查询用户支付方式列表
  methodList: (userCode: string) => requester.post('/payment/v1/method/list', { userCode }),
  // 新增支付方式v2
  accountSave: (data: any) => requester.post('/payment/v2/account/save', data),
  // 设置默认支付方式
  setDefaultCard: (data: { id: number }) => requester.post('/payment/v1/account/primary', data),
  // 增加钱包白名单
  addTrustWallet: (data: any) => requester.post('/wallet/v1/trust-wallet/addByCreator', data),
  // 获取信用卡支付的收据
  queryReceipt: (data: any) => requester.post('/wallet/transaction/v1/queryReceipt', data),
  // 验证邮箱是否可用
  checkEmail: (data: any) => requester.post('/dfans/check-email', data),
  // 删除用户支付账号(删除信用卡)
  deleteCard: (id: number) => requester.post('/payment/v1/account/remove', { id }),
  // 支付结果校验
  completePayment: (paymentIntent: string) =>
    requester.post(`/stripe/v1/complete-payment?paymentIntent=${paymentIntent}`, {}),
  // 为创作者发送邮箱验证码
  sendEmailCodeForAddWallet: (data: object | undefined) =>
    requester.post('/wallet/v1/trust-wallet/sendEmailCode', data, { headers: { isSeller: true } }),
  // 校验邮箱地址合法性
  verifyWallet: (data: object | undefined) =>
    requester.post('/wallet/v1/trust-wallet/verifyWallet', data, { headers: { isSeller: true } }),
  // 设置信任钱包为默认
  setPrimaryWallet: (data: object | undefined) =>
    requester.post('/wallet/v1/trust-wallet/setPrimary', data, { headers: { isSeller: true } }),
  // 删除信任钱包
  deleteTrustWallet: (data: object | undefined) =>
    requester.post('/wallet/v1/trust-wallet/delete', data, { headers: { isSeller: true } }),
  // telegram 轮询支付结果  telegram/get-pay-result
  telegramGetPayResult: (payNo: any) =>
    requester.post(`/telegram/get-pay-result?payNo=${payNo}`, {}),
  // kodo 加密货币接口
  findSupported: () => requester.post('/kodo/crypto/find-supported', {}),
  //  kodo 支付方式接口
  findPaymentTypes: () => requester.post('/kodo/find-payment-types', {}),
  //  kodo ramp列表接口
  findQuotes: (data: any) => requester.post('/kodo/find-quotes', data),
  // kodo 创建订单 (充值用)
  kodoCreateOrder: (data: any) => requester.post('kodo/checkout-intent', data),
  // 查询支付结果 整合
  chargeResult: (payNo: string) =>
    requester.post(`/charge/common/get-charge-result?payNo=${payNo}`, {}),
  // AlchemyPay 查询支持的数字货币
  alchemyPayQueryCrypto: () => requester.post('/alchemy-pay/v1/query/crypto', {}),
  // AlchemyPay 查询支持的支付方式
  alchemyPayQueryPaymentMethods: (data: any) =>
    requester.post('/alchemy-pay/v1/query/payment-method', data),
  // AlchemyPay 查询支付结果
  alchemyPayChargeResult: (payNo: string) =>
    requester.post(`/alchemy-pay/v1/query/order`, { payNo }),
  // AlchemyPay 查询购买价格
  alchemyPayQueryPrice: (data: any) => requester.post('/alchemy-pay/v1/query/price', data),
  // AlchemyPay 创建订单 (充值用)
  alchemyPayCreateOrder: (data: any) => requester.post('/alchemy-pay/v1/create/order', data),
  // 创建支付订单 整合
  createPaymentIntent: (data: any) => requester.post('/charge/common/create-payment-intent', data),
  // 多链 金额 wallet/v1/balance/queryByChainCode
  balanceQueryByCoinCode: (data: any) => requester.post('/wallet/v1/balance/queryByCoinCode', data),
  // 查询粉丝充值记录
  queryDepositHistory: (data: any) =>
    requester.post('/crypto/cryptoAddressTrxRecord/queryDepositHistory', data),
  // Authorize支付 保存用户卡信息
  saveCardInfo: (data: any) => requester.post('/charge/common/save-card-info', data),
  // Authorize支付 查询用户卡列表
  findCardInfo: () => requester.post('/charge/common/find-card-info', {}),
  // Authorize支付 预支付接口
  prePayment: (data: any) => requester.post('/charge/common/pre-payment', data),
  // Authorize 删除 卡信息
  deleteCardInfo: (cardId: string) =>
    requester.post(`/charge/common/delete-card-info?cardId=${cardId}`, {}),
  // Authorize 设置 卡信息为默认
  setDefaultCardInfo: (cardId: string) =>
    requester.post(`/charge/common/set-default-card?cardId=${cardId}`, {}),
  // 通过数字货币获取支付方式
  getPaymentMethods: (crypto: string) =>
    requester.post(`/alchemy-pay/v1/create/payment-method?crypto=${crypto}`, {}),
  // 查询用户和平台收入情况
  incomeUserPlatform: (data: { userCode: string }) =>
    requester.post('/user/revenue/flow/v1/income/user-platform', data),
  // 获取stripe卡列表
  findStripeCardInfo: () => requester.post('/posterify/pay/find-account', {}),
  // 删除stripe卡
  deleteStripeCard: (id: string) =>
    requester.post(`/posterify/pay/delete-account?payAccountId=${id}`, {}),
  // paypal 捕获订单
  captureOrder: (payNo: string) =>
    requester.post(`/charge/common/capture-order?payNo=${payNo}`, {}),
  // 法币提现申请状态
  getApplyStatus: () => requester.post('/creator/payout/get-apply-status', {}),
  // 新增或修改法币提现申请
  saveApply: (data: any) => requester.post('/creator/payout/apply-fiat-payout', data),
  // 模糊查询国家
  fuzzyCountry: (data: any) => requester.post('/creator/payout/fuzzy-country?countryName=', data),
  // 模糊查币种
  fuzzyCurrency: (data: any) =>
    requester.post('/creator/payout/fuzzy-currency?currencyCode=' + data, {}),
  // 获取ccbill oauth token
  getCcbillOauthToken: () => requester.post('/ccbill/get-auth-token', {}),
  // 获取USD提现卡列表
  getUSDCardList: () => requester.post('/creator/payout/find-trust-account-list', {}),
  // USD 提现
  transferUSD: (data: any) => requester.post('/withdraw/creator-start-withdraw', data),
}
